import React from "react";
import { css } from "styled-components";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-grid-system";

import { MarkdownGenerator } from "./Blocks.js";

import { Property, color } from "./style/Variables.js";

export const footerMinHeight = new Property(6, "em");

const Links = arr => {
  const classnames = "color-bg hover-underline";
  return (
    <ul>
      {arr.map((v, i) => {
        const { text, url } = v;
        const isExternal = url.indexOf("//") > -1;
        return (
          <li className="mb1 font-light" key={i}>
            {isExternal ? (
              <a className={classnames} href={url} target="_blank">
                {text}
              </a>
            ) : (
              <Link className={classnames} to={url}>
                {text}
              </Link>
            )}
          </li>
        );
      })}
    </ul>
  );
};

const Markdown = MarkdownGenerator({
  style: css`
    p {
      font-weight: 200;
      line-height: 1.86;
    }
  `,
  className: "body-large color-bg",
});

class Footer extends React.Component {
  static contextTypes = {
    copy: PropTypes.object,
  };
  renderHeader(children) {
    return <h4 className="h5 mb2 mmb1">{children}</h4>;
  }
  render() {
    const copy = this.context.copy.get("Footer");
    return (
      <div
        className="h7 bg-ib my2 px4 pmx1"
        style={
          window.innerWidth < 900
            ? {
                marginLeft: "-15px",
                marginBottom: "-15px",
                width: "calc(100% + 30px)",
              }
            : {}
        }
      >
        <Container className="pt3 pb2" fluid>
          <Row className="h-100 line-height-5">
            <Col
              className={`pt3 mt1 mb2`}
              style={
                window.innerWidth < 900
                  ? { paddingTop: "0", paddingLeft: "0" }
                  : {}
              }
              md={2}
            >
              {this.renderHeader(copy && copy.col1.title)}
              {copy ? Links(copy.col1.links) : false}
            </Col>
            <Col
              className={`pt3 mt1 mb2 ${
                window.innerWidth < 900 ? "border-top" : ""
              }`}
              style={
                window.innerWidth < 900
                  ? { borderColor: color.white_two, paddingLeft: "0" }
                  : { borderColor: color.white_two }
              }
              md={3}
            >
              {this.renderHeader(copy && copy.col2.title)}
              {copy ? Links(copy.col2.links) : false}
            </Col>
            <Col
              className={`pt3 mt1 mb2 ${
                window.innerWidth < 900 ? "border-top" : ""
              }`}
              style={
                window.innerWidth < 900
                  ? { borderColor: color.white_two, paddingLeft: "0" }
                  : { borderColor: color.white_two }
              }
              md={3}
            >
              {this.renderHeader(copy && copy.col3.title)}
              {copy ? Links(copy.col3.links) : false}
            </Col>
            <Col
              className={`pt3 mt1 mb2 ${
                window.innerWidth < 900
                  ? "border-top center"
                  : "border-left center"
              }`}
              style={
                window.innerWidth < 900
                  ? { borderColor: color.white_two }
                  : { borderColor: color.white_two }
              }
              md={4}
            >
              <Row>
                <Col
                  sm={8}
                  lg={10}
                  offset={{ sm: 2, lg: 1 }}
                  // style={window.innerWidth < 900 ? { padding: "" } : {}}
                >
                  <h4
                    id="customer-service"
                    className="h5 mb2 mmb1 px3 pmx0"
                    style={{ marginBottom: `${11}px` }}
                  >
                    {copy && copy.customer_service.title}
                  </h4>
                  <Markdown>{copy && copy.customer_service.body}</Markdown>
                </Col>
              </Row>

              <Row className="px3 mt2 pmx0">
                <Col
                  xs={9}
                  sm={4}
                  md={12}
                  lg={6}
                  offset={{ xs: 1.5, sm: 4, md: 0, lg: 3 }}
                >
                  <Row>
                    <Col xs={6} md={4} lg={6} offset={{ md: 1, lg: 0 }}>
                      <a
                        className={`inline-block color-bg font-light ico-${copy &&
                          copy.customer_service.link1.toLowerCase()}`}
                        href={
                          copy && copy.customer_service.link1_url
                            ? copy.customer_service.link1_url
                            : ""
                        }
                        target="_blank"
                      >
                        {copy && copy.customer_service.link1}
                      </a>
                    </Col>
                    <Col xs={6} md={4} lg={6} offset={{ md: 2, lg: 0 }}>
                      <a
                        className={`inline-block color-bg font-light ico-${copy &&
                          copy.customer_service.link2.toLowerCase()}`}
                        href={
                          copy && copy.customer_service.link2_url
                            ? copy.customer_service.link2_url
                            : ""
                        }
                      >
                        {copy && copy.customer_service.link2}
                      </a>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js